export enum RolloverTeamType {
  Destination = 'Destination',
  Origin = 'Origin',
}
